module.exports = __webpack_public_path__ + "img/hr-green-desert-bush-03.7c647382.png";